import React from "react";

const styles = {
  aboutSection: {
    maxWidth: 600,
    margin: "0 auto 32px auto",
    padding: "24px 18px 18px 18px",
    background: "#fff",
    boxShadow: "0 2px 12px rgba(201,161,74,0.07)",
    textAlign: "left",
    border: "1px solid #e0e0e0"
  },
  aboutTitle: {
    fontSize: 22,
    fontWeight: 600,
    color: "#C21833",
    margin: 0,
    letterSpacing: 0.5
  },
  aboutText: {
    fontSize: 15,
    color: "#4a5568",
    margin: "12px 0 0 0",
    lineHeight: 1.7
  }
};

export default function AboutUs() {
  return (
    <section style={styles.aboutSection}>
      <h2 style={styles.aboutTitle}>About Us</h2>
      <p style={styles.aboutText}>
        Hey everyone 👋,<br/>
        I started Cherry on top 🍒 with a dream to bring beautiful, affordable jewellery to everyone ✨ Growing up, I loved how a simple piece of jewellery could instantly lift my mood. That's why I wanted to create pieces that aren't just accessories, but a part of your story ❤️<br/>
        From dainty everyday wear to statement pieces for special moments, every design is crafted with love and care ✨ Our anti-tarnish jewellery is designed to make you shine, every day.
      </p>
    </section>
  );
}
